import React, { memo, useEffect, useRef, useState } from 'react';
import { Button, Collapse, ControlLabel, FormControl, FormGroup } from 'react-bootstrap';

import PropTypes from 'prop-types';
import { Dropdown, useDropdown } from '../../Dropdown';
import DatePicker from '../../DatePickers/DatePicker';

const FilterCreatedBody = ({ filter, onChangeFilter, ranges }) => {
  const dateToRef = useRef(null);
  const dateFromRef = useRef(null);
  const today = new Date().toISOString().split('T')[0];

  const { close } = useDropdown()

  const [filterSelected, setSelectedFilter] = useState({
    date_from: filter.date_from || null,
    date_to: filter.date_to || null,
    period_code: filter.period_code || null,
  });
  const { date_from, date_to, period_code } = filterSelected;

  const onChangePeriodCode = (e) => {
    const value = e.target.value;
    setSelectedFilter((prevState) => ({
      ...prevState,
      date_from: null,
      date_to: null,
      period_code: value,
    }))

    if (value === 'custom_range') {
      setTimeout(() => {
        dateFromRef.current.focus();
      }, 300)
    }
  }

  const onSubmitFilter = (e) => {
    e.preventDefault();
    try {
      if (filterSelected.period_code === 'custom_range' && (!filterSelected.date_from && !filterSelected.date_to)) {
        return;
      }

      onChangeFilter(filterSelected)
    } finally {
      close();
    }
  }

  const handleDateChange = (name, value) => {
    setSelectedFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (date_from && dateToRef.current) {
      if (!date_to) {
        dateToRef.current.focus();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date_from]);

  return (
    <>
      <Dropdown.Body pl={16} pr={16}>
        <FormGroup style={{ marginBottom: period_code === 'custom_range' ? null : 0 }}>
          <FormControl
            onChange={onChangePeriodCode}
            value={period_code}
            componentClass="select"
          >
            {ranges.map((range) => <option key={range.code} value={range.code}>{range.title}</option>)}
          </FormControl>
        </FormGroup>
        <Collapse in={period_code === 'custom_range'}>
          <div>
            <FormGroup>
              <ControlLabel>From</ControlLabel>
              <DatePicker
                ref={dateFromRef}
                value={date_from}
                onChange={(value) => handleDateChange('date_from', value)}
                maxDate={today}
              />
            </FormGroup>
            <FormGroup style={{ marginBottom: 0 }}>
              <ControlLabel>To</ControlLabel>
              <DatePicker
                ref={dateToRef}
                value={date_to}
                onChange={(value) => handleDateChange('date_to', value)}
                minDate={date_from ? new Date(date_from) : null}
                maxDate={today}
              />
            </FormGroup>
          </div>
        </Collapse>
      </Dropdown.Body>
      <Dropdown.Footer p={16}>
        <Button
          block
          bsStyle="primary"
          onClick={onSubmitFilter}
        >
          Apply
        </Button>
      </Dropdown.Footer>
    </>
  );
}

FilterCreatedBody.propTypes = {
  filter: PropTypes.object,
  onChangeFilter: PropTypes.func,
  ranges: PropTypes.array,
};

export default memo(FilterCreatedBody);
